/**
 * /shift-schedule — страница: состояние, календарь, числа и выгрузки.
 *
 * Расчёт целиком в core.js (window.ShiftSchedule); здесь только то, что
 * человек видит и нажимает. Состояние — один объект `st`: он же уходит в
 * «Мои графики» (__toolDraft.editor), в ссылку (#s=, lz-string) и в файлы.
 * Вид (какой месяц открыт, какая бригада показана) — отдельно, в `ui`:
 * открыв график завтра, человек видит свой текущий месяц, а не прошлый.
 */
(function () {
'use strict';

var S = window.ShiftSchedule;
var CFG = window.__SS || {};
if (!S || !document.getElementById('ssRoot')) return;

var T = CFG.t || {};
var SLUG = CFG.slug || 'shift-schedule';
var LOC = CFG.locale || 'en';
var IL = (window.__intlLocale && window.__intlLocale()) || LOC;
var RTL = document.documentElement.getAttribute('dir') === 'rtl';
var WS = CFG.weekStart | 0;
var DEC = CFG.decimal === ',' ? ',' : '.';
var DAY = S.DAY;
var SITE = String(location.hostname || '').replace(/^www\./, '');
var KINDS = ['D', 'N', 'F', 'S'];
var CYCLE = ['D', 'N', 'F', 'S', 'O'];
var COLORS = { D: '#d99a0b', N: '#6366f1', F: '#e0365a', S: '#0d9488', vac: '#16a34a', sick: '#ea580c' };
var SHEET = { D: '#fde9b5', N: '#d9dafd', F: '#f9cdd7', S: '#c9efe9', vac: '#c8efd4', sick: '#fbd9c4' };
/* Дежурные — каждый своим цветом: в месяце из одних «Иван…», «Петр…» видно, кто
   где, только по цвету. Восемь оттенков, дальше по кругу; те же — в картинке и листе. */
var PP = ['#f6d58e', '#c7d2fe', '#bbf7d0', '#fecdd3', '#bae6fd', '#fde68a', '#ddd6fe', '#fed7aa'];

function $(id) { return document.getElementById(id); }
function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}
/* В RTL-строке «08:00–20:00» алгоритм bidi переставляет числа вокруг тире, и
   смена читается «20:00–08:00». Изоляция LRI…PDI держит интервал слева направо и
   не цепляет к нему соседние числа (LRM по бокам тире цеплял «12 ·») — на экране,
   в картинке и в PDF. */
function ltrTimes(s) { return RTL ? String(s).replace(/(\d{1,2}(?::\d{2})?)–(\d{1,2}(?::\d{2})?)/g, '\u2066$1–$2\u2069') : s; }
function t(k, r) {
    var s = T[k] != null ? String(T[k]) : k;
    if (r) {
        Object.keys(r).sort(function (a, b) { return b.length - a.length; }).forEach(function (n) {
            s = s.split(':' + n).join(String(r[n]));
        });
    }
    return ltrTimes(s);
}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
/* Отпечаток графика для UID событий .ics. Раньше UID был «дата-бригада-вид»,
   и у двух разных графиков (муж и жена в одном календаре) совпадал: второй
   импорт заменял события первого. Отпечаток содержимого, а не случайный номер:
   тот же график при повторной выгрузке даёт те же UID (календарь обновит, а не
   задвоит), другой график — другие. FNV-1a, 32 бита. */
function fingerprint(o) {
    var s = JSON.stringify(o), h = 0x811c9dc5;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return h.toString(36);
}
function cap(s) { s = String(s || ''); return s.charAt(0).toLocaleUpperCase(IL) + s.slice(1); }
/* Вид смены как часть фразы: «дневная смена», «сутки». */
function kp(k) { return t('kp_' + k); }
function stage(n, m) { try { if (window.__stage) window.__stage(n, m || {}); } catch (e) {} }
/* Телеметрия отвечает на три вопроса: дошёл ли человек до СВОЕГО графика
   (стадия scheme — он сменил схему, дату или время и видит результат), до
   выдачи (complete), и что ему было непонятно (tool_diagnostic: отклонённый
   ввод, пустая выгрузка). Действия — feature_use, один раз на пару
   «действие + значение»; ни названий, ни имён сотрудников, ни дат в них нет. */
var sentFeat = {};
function feature(action, extra) {
    var k = action + JSON.stringify(extra || {});
    if (sentFeat[k]) return;
    sentFeat[k] = 1;
    try { if (window.__ae) window.__ae('feature_use', Object.assign({ slug: SLUG, action: action }, extra || {})); } catch (e) {}
}
function diag(issue, extra) { try { if (window.__aeDiagnostic) window.__aeDiagnostic(Object.assign({ issue: issue }, extra || {})); } catch (e) {} }
var schemed = false, overlapSent = false;
function firstScheme() { if (schemed) return; schemed = true; stage('scheme', { p: st.preset, crews: st.crews.length }); }
function toast(msg, type) { try { if (window.__toast) window.__toast(msg, type || 'info'); } catch (e) {} }

/* ── числа и даты по языку страницы ───────────────────────────────────── */
var nf1 = new Intl.NumberFormat(IL, { maximumFractionDigits: 1 });
var nf0 = new Intl.NumberFormat(IL, { maximumFractionDigits: 0 });
function hrs(min) { return nf1.format(Math.round(min / 6) / 10); }
var dfCache = {};
function fmt(dn, opts) {
    var key = JSON.stringify(opts);
    if (!dfCache[key]) dfCache[key] = new Intl.DateTimeFormat(IL, Object.assign({ timeZone: 'UTC' }, opts));
    return dfCache[key].format(new Date(dn * 864e5));
}
function monthName(y, m) { return fmt(S.dnOf(y, m, 1), { month: 'long', year: 'numeric' }); }
function monthShort(m) { return fmt(S.dnOf(2026, m, 1), { month: 'short' }); }
function dayLong(dn) { return fmt(dn, { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' }); }
function dayShort(dn) { return fmt(dn, { weekday: 'short', day: 'numeric', month: 'short' }); }
/* 5 января 2026 — понедельник: опорная неделя для подписей дней. */
var MONDAY = S.dnOf(2026, 1, 5);
function wdName(i, style) { return fmt(MONDAY + i, { weekday: style || 'short' }); }
/* Выходные дни недели: в арабских странах обычно пятница и суббота. */
var WEEKEND = LOC === 'ar' ? [4, 5] : [5, 6];
function isWeekend(i) { return WEEKEND.indexOf(i) >= 0; }
/* Недельные схемы стоят по дням недели с понедельника; для ar выходные
   приходятся на пятницу и субботу (5/2) и на пятницу (6/1). */
function presetSeq(p) {
    if (p.week && LOC === 'ar') return p.id === '5-2' ? 'DDDDOOD' : p.id === '6-1' ? 'DDDDODD' : p.seq;
    return p.seq;
}
function span(s, e) {
    return ltrTimes(S.hm(s) + '–' + S.hm(e));
}
function spanShort(s, e) {
    var a = S.hm(s), b = S.hm(e);
    if (/:00$/.test(a) && /:00$/.test(b)) return ltrTimes(a.slice(0, 2) + '–' + b.slice(0, 2));
    return ltrTimes(a + '–' + b);
}
function todayDn() { var n = new Date(); return S.dnOf(n.getFullYear(), n.getMonth() + 1, n.getDate()); }
function nowMin() { var n = new Date(); return todayDn() * DAY + n.getHours() * 60 + n.getMinutes(); }
/* Смещение пояса этого устройства для минуты стенных часов: ночь перевода на
   летнее время короче на час, на зимнее — длиннее (core.js, workOf). Кэш по
   часу: год графика — тысячи вызовов. */
var offCache = {};
function offsetAt(min) {
    var hk = Math.floor(min / 60);
    if (offCache[hk] !== undefined && S.mod(min, 60) === 0) return offCache[hk];
    var o = S.ymdOf(Math.floor(min / DAY)), tm = S.mod(min, DAY);
    var v = new Date(o.y, o.m - 1, o.d, Math.floor(tm / 60), tm % 60).getTimezoneOffset();
    if (S.mod(min, 60) === 0) offCache[hk] = v;
    return v;
}
function statOpts() { return { weekly: st.weekly, offsetAt: offsetAt }; }
/** Работа одной смены по датам [A, B): {work, night, holiday, dst}. */
function shiftWork(c, sh, A, B) { return S.workOf(c, sh.segs, A == null ? -Infinity : A, B == null ? Infinity : B, offsetAt); }

/* ── состояние ────────────────────────────────────────────────────────── */
/* Ночное окно по умолчанию — из перевода: у de 23:00–06:00 (ArbZG § 2 Abs. 3). */
var NIGHT0 = (function () {
    var m = /^(\d{2}:\d{2})-(\d{2}:\d{2})$/.exec(String(T.night_default || ''));
    var a = m ? S.parseHm(m[1]) : null, b = m ? S.parseHm(m[2]) : null;
    return [a !== null ? a : 1320, b !== null ? b : 360];
})();
/* Оплата по умолчанию: доплата за ночь — из перевода (ru 20 % по ТК РФ ст. 154 и
   постановлению № 554, pt 20 % по CLT art. 73, у остальных закона «по умолчанию»
   нет — 0), праздники ×2 — только с календарём РФ (ст. 153). */
var PAY_NIGHT0 = Math.max(0, Math.min(300, parseInt(T.pay_night_default, 10) || 0));
var PAY_HOL0 = CFG.calDefault === 'ru' ? 2 : 1;
var REMINDS = [0, 30, 60, 120, 1440];
var HOLX = [1, 1.5, 2, 2.5, 3];
function fresh() {
    var td = todayDn();
    return {
        v: 1, mode: 'shifts', title: '', preset: '2-2', seq: 'DDOO', week: false,
        kinds: clone(S.KIND_DEFAULTS), userKinds: {}, anchor: S.isoOf(td),
        crews: [{ n: '', o: 0 }], marks: {},
        cal: CFG.calDefault === 'ru' ? 'ru' : 'none', weekly: 40, period: 'month', nightFrom: NIGHT0[0], nightTo: NIGHT0[1],
        duty: { people: '', rule: 'daily', every: 2, start: S.isoOf(td) },
        remind: 0, pay: { rate: 0, night: PAY_NIGHT0, hol: PAY_HOL0 },
        cmp: { p: '', a: S.isoOf(td) },
    };
}
/** Сохранённый или присланный ссылкой график — через ту же проверку полей. */
function upgrade(o) {
    var f = fresh();
    if (!o || typeof o !== 'object') return f;
    if (o.mode === 'duty') f.mode = 'duty';
    if (typeof o.title === 'string') f.title = o.title.slice(0, 80);
    if (typeof o.preset === 'string' && (o.preset === 'custom' || S.preset(o.preset))) f.preset = o.preset;
    f.seq = S.cleanSeq(o.seq || f.seq);
    f.week = !!o.week && f.seq.length === 7;
    if (o.kinds && typeof o.kinds === 'object') {
        KINDS.forEach(function (k) {
            var v = o.kinds[k];
            if (v && isFinite(v.s) && isFinite(v.l) && isFinite(v.b)) f.kinds[k] = { s: +v.s, l: +v.l, b: +v.b };
        });
    }
    if (o.userKinds && typeof o.userKinds === 'object') {
        KINDS.forEach(function (k) {
            var v = o.userKinds[k];
            if (v && isFinite(v.s) && isFinite(v.l) && isFinite(v.b)) f.userKinds[k] = { s: +v.s, l: +v.l, b: +v.b };
        });
    }
    if (S.parseIso(o.anchor) !== null) f.anchor = o.anchor;
    if (Array.isArray(o.crews) && o.crews.length) {
        f.crews = o.crews.slice(0, 6).map(function (c) {
            return { n: typeof (c && c.n) === 'string' ? c.n.slice(0, 40) : '', o: isFinite(c && c.o) ? Math.round(c.o) : 0 };
        });
    }
    if (o.marks && typeof o.marks === 'object') {
        Object.keys(o.marks).forEach(function (ci) {
            var src = o.marks[ci], dst = {};
            if (!src || typeof src !== 'object' || !(+ci >= 0 && +ci < 6)) return;
            Object.keys(src).forEach(function (iso) {
                if (S.parseIso(iso) !== null && /^(vac|sick|extra|off)$/.test(src[iso])) dst[iso] = src[iso];
            });
            f.marks[ci] = dst;
        });
    }
    if (o.cal === 'ru' || o.cal === 'none') f.cal = o.cal;
    if ([40, 39, 36, 35, 30, 24].indexOf(+o.weekly) >= 0) f.weekly = +o.weekly;
    if (/^(month|quarter|half|year)$/.test(o.period)) f.period = o.period;
    if (isFinite(o.nightFrom)) f.nightFrom = S.mod(Math.round(o.nightFrom), DAY);
    if (isFinite(o.nightTo)) f.nightTo = S.mod(Math.round(o.nightTo), DAY);
    if (REMINDS.indexOf(+o.remind) >= 0) f.remind = +o.remind;
    if (o.cmp && typeof o.cmp === 'object') {
        if (typeof o.cmp.p === 'string' && (o.cmp.p === '' || S.preset(o.cmp.p))) f.cmp.p = o.cmp.p;
        if (S.parseIso(o.cmp.a) !== null) f.cmp.a = o.cmp.a;
    }
    if (o.pay && typeof o.pay === 'object') {
        if (isFinite(o.pay.rate) && +o.pay.rate >= 0 && +o.pay.rate <= 1e6) f.pay.rate = +o.pay.rate;
        if (isFinite(o.pay.night) && +o.pay.night >= 0 && +o.pay.night <= 300) f.pay.night = Math.round(+o.pay.night);
        if (HOLX.indexOf(+o.pay.hol) >= 0) f.pay.hol = +o.pay.hol;
    }
    if (o.duty && typeof o.duty === 'object') {
        if (typeof o.duty.people === 'string') f.duty.people = o.duty.people.slice(0, 4000);
        if (/^(daily|workdays|weekly|every)$/.test(o.duty.rule)) f.duty.rule = o.duty.rule;
        if (isFinite(o.duty.every)) f.duty.every = Math.max(1, Math.min(31, Math.round(o.duty.every)));
        if (S.parseIso(o.duty.start) !== null) f.duty.start = o.duty.start;
    }
    return f;
}

var st = fresh();
var td0 = S.ymdOf(todayDn());
var ui = { y: td0.y, m: td0.m, view: 'month', crew: 0, mark: '', sel: null, range: 'month' };
var touched = false;
var SEQ_HINT = ($('ssSeqHint') && $('ssSeqHint').textContent) || '';
var drafts = null;
var reported = false;

function presetOf() { return S.preset(st.preset); }
function anchorDn() { var a = S.parseIso(st.anchor); return a !== null ? a : todayDn(); }
function E() {
    var p = presetOf();
    return S.normalize({
        seq: st.seq, week: st.week,
        cal: (st.cal === 'ru' && st.week && p && p.cal) ? 'ru' : null,
        anchor: anchorDn(), kinds: st.kinds, crews: st.crews, marks: st.marks,
        holidays: st.cal === 'ru' ? 'ru' : null, nightFrom: st.nightFrom, nightTo: st.nightTo,
    });
}
/* Второй график — для «когда мы оба свободны» (муж и жена, двое коллег): готовая
   схема и её первый день, времена смен — как у схемы по умолчанию. Свободен —
   день без начала смены (выходной, отсыпной, отпуск). */
function cmpE() {
    var p = st.cmp && st.cmp.p ? S.preset(st.cmp.p) : null;
    if (!p) return null;
    var a = S.parseIso(st.cmp.a);
    return S.normalize({ seq: presetSeq(p), week: !!p.week, cal: (st.cal === 'ru' && p.week && p.cal) ? 'ru' : null,
        anchor: a !== null ? a : todayDn(), kinds: p.kinds || null });
}
function bothFree(c, c2, dn) { return !S.WORK[S.cell(c, ui.crew, dn).k] && !S.WORK[S.cell(c2, 0, dn).k]; }
function crewName(i) {
    var c = st.crews[i];
    return (c && c.n && c.n.trim()) ? c.n.trim() : t('crew_default', { n: i + 1 });
}
function people() {
    return String(st.duty.people || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 100);
}
function dutyCfg() {
    var p = people();
    var sd = S.parseIso(st.duty.start);
    return { n: p.length, start: sd !== null ? sd : todayDn(), rule: st.duty.rule, every: st.duty.every, cal: st.cal === 'ru' ? 'ru' : null, weekend: WEEKEND, people: p };
}

/* ── сохранение ───────────────────────────────────────────────────────── */
/* Работа живёт в «Моих графиках» (IndexedDB, асинхронно). Последняя версия
   ещё и в __toolSettings: страница рисуется с ней сразу, без мигания схемы
   по умолчанию, пока «Мои графики» поднимают ту же работу. */
function save() {
    touched = true;
    if (window.__toolSettings) window.__toolSettings.save(SLUG, 'last', st);
    if (drafts) { try { drafts.touch(true); } catch (e) {} }
}
function changed() { render(); save(); }
function label() {
    if (st.title) return st.title;
    if (st.mode === 'duty') return t('drafts_label_duty');
    return (st.preset === 'custom' ? t('p_custom') : t('p_' + st.preset)) + ' · ' + fmt(anchorDn(), { day: 'numeric', month: 'short', year: 'numeric' });
}

/* ── схема ────────────────────────────────────────────────────────────── */
function applyKinds() {
    var p = presetOf();
    var k = clone(S.KIND_DEFAULTS);
    KINDS.forEach(function (x) { if (st.userKinds[x]) k[x] = clone(st.userKinds[x]); });
    if (p && p.kinds) Object.keys(p.kinds).forEach(function (x) { k[x] = clone(p.kinds[x]); });
    st.kinds = k;
}
function setPreset(id) {
    var p = S.preset(id);
    if (id === 'custom') {
        if (st.week) { st.anchor = S.isoOf(todayDn() - S.dow(todayDn())); }
        st.preset = 'custom'; st.week = false;
    } else if (p) {
        st.preset = id; st.seq = presetSeq(p); st.week = !!p.week;
        applyKinds();
    }
    if (st.crews.length > 1) autoCrews();
    feature('preset', { p: id });
    firstScheme();
    changed();
}
function toCustom() {
    if (st.preset === 'custom') return;
    if (st.week) st.anchor = S.isoOf(todayDn() - S.dow(todayDn()));
    st.preset = 'custom'; st.week = false;
}
function autoCrews() {
    var L = st.week ? 7 : st.seq.length;
    var o = S.autoOffsets(L, st.crews.length);
    st.crews.forEach(function (c, i) { c.o = o[i]; });
}

/* ── рендер: рейка ────────────────────────────────────────────────────── */
function setSeg(root, v) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-v],[data-p],[data-m]'), function (b) {
        var val = b.getAttribute('data-v');
        if (val === null) val = b.getAttribute('data-p');
        if (val === null) val = b.getAttribute('data-m');
        var on = String(val) === String(v);
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
}
function renderRail() {
    var duty = st.mode === 'duty';
    setSeg($('ssMode'), st.mode);
    Array.prototype.forEach.call(document.querySelectorAll('#ssRoot [data-mode]'), function (el) {
        el.hidden = el.getAttribute('data-mode') !== st.mode;
    });
    if ($('ssTitle').value !== st.title && document.activeElement !== $('ssTitle')) $('ssTitle').value = st.title;
    if (duty) { renderDutyRail(); return; }

    setSeg($('ssPresets'), st.preset);
    $('ssPdesc').textContent = st.preset === 'custom' ? t('pd_custom') : t('pd_' + st.preset);

    var seqEl = $('ssSeq'), html = '';
    for (var i = 0; i < st.seq.length; i++) {
        var k = st.seq.charAt(i);
        var sub = st.week ? wdName(i, 'short') : String(i + 1);
        html += '<button type="button" class="ss-seq-c k-' + k + '" data-i="' + i + '" aria-label="' +
            esc(t('seq_cell', { n: st.week ? wdName(i, 'long') : i + 1, kind: t('k_' + k) })) + '">' +
            esc(t('l_' + k)) + '<small>' + esc(sub) + '</small></button>';
    }
    seqEl.innerHTML = html;
    var p = presetOf();
    $('ssSeqLen').textContent = st.week ? t('seq_week_note') : t('seq_len', { n: st.seq.length });
    $('ssSeqDel').disabled = st.week || st.seq.length <= 1;
    $('ssSeqAdd').disabled = st.week || st.seq.length >= 62;
    $('ssSeqHint').textContent = (st.week && p && p.cal && st.cal === 'ru') ? t('seq_cal_note') : SEQ_HINT;
    $('ssAnchorF').hidden = st.week;
    if ($('ssAnchor').value !== st.anchor) $('ssAnchor').value = st.anchor;

    renderKindsRail();
    /* Смена длиннее промежутка до следующей (48 ч «сутки через сутки») —
       часы посчитались бы дважды: говорим об этом под временем смен. */
    var ov = S.overlaps(E(), 0), ovEl = $('ssOverlap');
    if (ovEl) { ovEl.hidden = !ov; ovEl.textContent = ov ? t('warn_overlap') : ''; }
    if (ov && !overlapSent) { overlapSent = true; diag('shift_overlap', { p: st.preset }); }

    setSeg($('ssCrewN'), st.crews.length);
    var ch = '';
    if (st.crews.length > 1) {
        st.crews.forEach(function (c, i) {
            ch += '<div class="ss-crew" data-c="' + i + '">' +
                '<input class="tc-in" type="text" maxlength="40" data-name="' + i + '" value="' + esc(c.n) + '" placeholder="' + esc(t('crew_default', { n: i + 1 })) + '" aria-label="' + esc(t('lbl_name')) + ' ' + (i + 1) + '">' +
                '<button type="button" class="ss-ib" data-off="' + i + '" data-d="-1" aria-label="' + esc(t('offset_minus')) + '">−</button>' +
                '<span class="ss-off">' + esc(t('offset', { n: c.o })) + '</span>' +
                '<button type="button" class="ss-ib" data-off="' + i + '" data-d="1" aria-label="' + esc(t('offset_plus')) + '">+</button>' +
                '</div>';
        });
    }
    var crewsEl = $('ssCrews');
    if (!crewsEl.contains(document.activeElement)) crewsEl.innerHTML = ch;
    else Array.prototype.forEach.call(crewsEl.querySelectorAll('.ss-off'), function (el, i) { el.textContent = t('offset', { n: st.crews[i].o }); });
    $('ssCrewAutoRow').hidden = st.crews.length < 2;

    setSeg($('ssMarkPick'), ui.mark);
    var mk = st.marks[ui.crew] || {}, n = Object.keys(mk).length;
    $('ssMarksN').textContent = st.crews.length > 1 ? t('marks_for', { name: crewName(ui.crew) }) : (n ? t('marks_count', { n: n }) : '');
    $('ssMarksClear').disabled = !n;

    if ($('ssCalSel').value !== st.cal) $('ssCalSel').value = st.cal;
    $('ssNormFields').hidden = st.cal !== 'ru';
    if ($('ssWeekly').value !== String(st.weekly)) $('ssWeekly').value = String(st.weekly);
    if ($('ssPeriod').value !== st.period) $('ssPeriod').value = st.period;
    if (document.activeElement !== $('ssPayRate')) $('ssPayRate').value = st.pay.rate > 0 ? String(st.pay.rate) : '';
    if (document.activeElement !== $('ssPayNight')) $('ssPayNight').value = String(st.pay.night);
    if ($('ssPayHol').value !== String(st.pay.hol)) $('ssPayHol').value = String(st.pay.hol);
    $('ssPayHolF').hidden = st.cal !== 'ru';
    if ($('ssCmpPreset').value !== st.cmp.p) $('ssCmpPreset').value = st.cmp.p;
    if ($('ssCmpAnchor').value !== st.cmp.a) $('ssCmpAnchor').value = st.cmp.a;
    var cp = st.cmp.p ? S.preset(st.cmp.p) : null;
    $('ssCmpAnchorF').hidden = !cp || !!cp.week;
    if (document.activeElement !== $('ssNightFrom')) $('ssNightFrom').value = S.hm(st.nightFrom);
    if (document.activeElement !== $('ssNightTo')) $('ssNightTo').value = S.hm(st.nightTo);
}

function renderKindsRail() {
    var used = S.kindSet(st.seq);
    var box = $('ssKinds');
    if (box.contains(document.activeElement) && box.getAttribute('data-used') === used.join('')) {
        used.forEach(function (k) {
            var K = st.kinds[k], el = box.querySelector('[data-kspan="' + k + '"]');
            if (el) el.textContent = t('kind_span', { span: span(K.s, K.s + K.l), h: hrs(K.l - K.b) });
        });
        return;
    }
    box.setAttribute('data-used', used.join(''));
    var html = '';
    used.forEach(function (k) {
        var K = st.kinds[k];
        html += '<div class="ss-kind">' +
            '<div class="ss-kind-h"><span class="ss-dot k-' + k + '" aria-hidden="true"></span>' + esc(t('k_' + k)) +
            ' <span class="ss-kind-span" data-kspan="' + k + '">' + esc(t('kind_span', { span: span(K.s, K.s + K.l), h: hrs(K.l - K.b) })) + '</span></div>' +
            '<div class="tc-f"><label class="tc-f-l" for="ssK' + k + 's">' + esc(t('lbl_start')) + '</label><input class="tc-in" id="ssK' + k + 's" data-k="' + k + '" data-f="s" type="time" step="300" value="' + S.hm(K.s) + '"></div>' +
            '<div class="tc-f"><label class="tc-f-l" for="ssK' + k + 'l">' + esc(t('lbl_hours')) + '</label><input class="tc-in" id="ssK' + k + 'l" data-k="' + k + '" data-f="l" type="number" inputmode="decimal" min="0.25" max="48" step="0.25" value="' + (K.l / 60) + '"></div>' +
            '<div class="tc-f"><label class="tc-f-l" for="ssK' + k + 'b">' + esc(t('lbl_break')) + '</label><input class="tc-in" id="ssK' + k + 'b" data-k="' + k + '" data-f="b" type="number" inputmode="numeric" min="0" max="240" step="5" value="' + K.b + '"></div>' +
            '</div>';
    });
    box.innerHTML = html;
    Array.prototype.forEach.call(box.querySelectorAll('input[type=time]'), function (inp) {
        if (window.__timeCommit) window.__timeCommit(inp, function () { setKind(inp); });
        else inp.addEventListener('change', function () { setKind(inp); });
    });
}
/* Поле, которое не приняло число, говорит почему — рядом с собой, а не
   молча возвращает прежнее (стенд 22.10: «50 ч» и «перерыв 500 мин» просто
   откатывались, и человек не понимал, что не так). */
function fieldNote(inp, key, r) {
    /* Строкой под рядом полей: внутри ячейки сетки сообщение подбрасывало своё
       поле выше соседних (снимок iPhone 13, 22.10). У времени смены ряд — вся
       карточка вида смены (сетка, сообщение — на всю ширину), у пар полей — после пары. */
    if (!inp) return;
    var kind = inp.closest('.ss-kind'), row = kind || inp.closest('.tc-fields') || inp.closest('.tc-f') || inp.parentNode;
    if (!row) return;
    var p = row._ssErr;
    if (!p || !p.isConnected) {
        p = document.createElement('p'); p.className = 'ss-err'; p.setAttribute('role', 'alert');
        if (kind) kind.appendChild(p); else row.parentNode.insertBefore(p, row.nextSibling);
        row._ssErr = p;
    }
    p.textContent = t(key, r);
    clearTimeout(p._t);
    p._t = setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 7000);
    diag('input_rejected', { field: key });
}
function setKind(inp) {
    var k = inp.getAttribute('data-k'), f = inp.getAttribute('data-f');
    var K = clone(st.kinds[k]), clamped = false;
    if (f === 's') { var v = S.parseHm(inp.value); if (v === null) { inp.value = S.hm(K.s); fieldNote(inp, 'err_time'); return; } K.s = v; }
    else if (f === 'l') { var h = parseFloat(String(inp.value).replace(',', '.')); if (!(h >= 0.25 && h <= 48)) { inp.value = K.l / 60; fieldNote(inp, 'err_hours'); return; } K.l = Math.round(h * 60); if (K.b > K.l - 15) { K.b = Math.max(0, K.l - 15); clamped = true; } }
    else { var b = parseInt(inp.value, 10); if (!(b >= 0 && b <= 240)) { inp.value = K.b; fieldNote(inp, 'err_break'); return; } K.b = Math.min(b, K.l - 15); clamped = b !== K.b; }
    st.kinds[k] = K;
    var p = presetOf();
    if (!(p && p.kinds && p.kinds[k])) st.userKinds[k] = clone(K);
    feature('kind_time', { k: k, f: f });
    firstScheme();
    changed();
    if (clamped) {
        var bi = $('ssK' + k + 'b');
        if (bi) { bi.value = K.b; fieldNote(bi, 'err_break_long', { n: K.b }); }
    }
}

function renderDutyRail() {
    var ta = $('ssDutyList');
    if (document.activeElement !== ta && ta.value !== st.duty.people) ta.value = st.duty.people;
    setSeg($('ssRule'), st.duty.rule);
    $('ssEveryF').hidden = st.duty.rule !== 'every';
    if (document.activeElement !== $('ssEvery')) $('ssEvery').value = st.duty.every;
    if ($('ssDutyStart').value !== st.duty.start) $('ssDutyStart').value = st.duty.start;
}
function syncRemind() { var r = $('ssRemind'); if (r && r.value !== String(st.remind)) r.value = String(st.remind); }

/* ── рендер: сегодня ──────────────────────────────────────────────────── */
function renderNow() {
    var panel = $('ssNowPanel');
    panel.hidden = false;
    var main = $('ssNowMain'), sub = $('ssNowSub'), now = nowMin(), td = todayDn();
    if (st.mode === 'duty') {
        var d = dutyCfg();
        if (!d.n) { main.textContent = t('duty_empty'); sub.textContent = ''; return; }
        var i = S.dutyIndex(d, td);
        main.textContent = i >= 0 ? t('now_duty', { name: d.people[i] }) : t('now_duty_none');
        sub.textContent = '';
        for (var x = td + 1; x < td + 120; x++) {
            var j = S.dutyIndex(d, x);
            if (j >= 0 && (i < 0 || j !== i)) { sub.textContent = t('now_duty_next', { name: d.people[j], when: dayShort(x) }); break; }
        }
        return;
    }
    var c = E(), crew = ui.crew;
    var prefix = st.crews.length > 1 ? t('now_crew', { name: crewName(crew) }) : '';
    var list = S.shifts(c, crew, td - 2, td + 1), cur = null, todayShift = null, doneToday = null;
    list.forEach(function (sh) {
        if (sh.s <= now && now < sh.e) cur = sh;
        if (sh.dn === td && sh.s > now && !todayShift) todayShift = sh;
        if (sh.dn === td && sh.e <= now) doneToday = sh;
    });
    var cellToday = S.cell(c, crew, td), line;
    if (cur) line = t('now_running', { kind: kp(cur.k), to: S.hm(cur.e) });
    else if (todayShift) line = t('now_work', { kind: kp(todayShift.k), from: S.hm(todayShift.s), to: S.hm(todayShift.e) });
    /* Смена сегодня уже кончилась — день не «выходной» (стенд 22.10: в 22:45
       после смены 08:00–20:00 «Сегодня» писало «Сегодня выходной»). */
    else if (doneToday) line = t('now_done', { to: S.hm(doneToday.e) });
    else if (cellToday.mark && cellToday.mark !== 'extra') line = t('now_mark', { mark: t('mark_' + cellToday.mark).toLowerCase() });
    else line = t('now_off');
    /* «Бригада 2: сегодня выходной» — после имени фраза идёт со строчной. */
    main.textContent = prefix ? prefix + line.charAt(0).toLocaleLowerCase(IL) + line.slice(1) : line;
    var nx = S.nextShift(c, crew, cur ? cur.e : (todayShift ? todayShift.e : now), 400);
    if (nx) sub.textContent = t('now_next', { when: dayShort(nx.dn), kind: kp(nx.k), from: S.hm(nx.s), to: S.hm(nx.e) });
    else sub.textContent = cur || todayShift ? '' : t('now_none');
}

/* ── рендер: календарь ────────────────────────────────────────────────── */
function calDayOff(dn) { return st.cal === 'ru' && (S.ruDayOff(dn) === true || (S.ruDayOff(dn) === null && S.ruHoliday(dn))); }
function weekHeader() {
    var h = '';
    for (var i = 0; i < 7; i++) {
        var d = (WS + i) % 7;
        h += '<span class="ss-wd' + (isWeekend(d) ? ' we' : '') + '">' + esc(wdName(d, 'short')) + '</span>';
    }
    return h;
}
function markLabel(m) { return t('lm_' + m); }
function dayCellShifts(c, dn) {
    var x = S.cell(c, ui.crew, dn);
    var cls = ['ss-day'], inner = '<span class="ss-dn">' + nf0.format(S.ymdOf(dn).d) + '</span>', aria = dayLong(dn);
    if (S.WORK[x.k]) {
        var sg = S.segments(c, dn, x.k, x.short);
        cls.push('k-' + x.k);
        inner += '<span class="ss-b">' + esc(t('l_' + x.k)) + '</span><span class="ss-tm">' + esc(spanShort(sg.s, sg.e)) + '</span>';
        aria += ', ' + t('k_' + x.k) + ' ' + span(sg.s, sg.e);
    } else {
        var prev = S.cell(c, ui.crew, dn - 1).k;
        if ((prev === 'N' || prev === 'F') && !x.mark) inner += '<span class="ss-tm">' + esc(t('k_sleep')) + '</span>';
        aria += ', ' + t('k_O');
    }
    if (x.mark) { inner += '<span class="ss-mk ' + x.mark + '">' + esc(markLabel(x.mark)) + '</span>'; aria += ', ' + t('mark_' + x.mark); }
    var c2 = cmpE();
    if (c2 && bothFree(c, c2, dn)) { cls.push('both'); aria += ', ' + t('both_free'); }
    if (calDayOff(dn)) cls.push('hol');
    if (st.cal === 'ru' && S.ruShort(dn)) cls.push('short');
    if (dn === todayDn()) cls.push('today');
    if (dn === ui.sel) cls.push('sel');
    return '<button type="button" class="' + cls.join(' ') + '" data-dn="' + dn + '" aria-label="' + esc(aria) + '">' + inner + '</button>';
}
function dayCellDuty(d, dn) {
    var i = d.n ? S.dutyIndex(d, dn) : -1;
    var cls = ['ss-day'], inner = '<span class="ss-dn">' + nf0.format(S.ymdOf(dn).d) + '</span>', aria = dayLong(dn);
    if (i >= 0) { inner += '<span class="ss-who" dir="auto">' + esc(d.people[i]) + '</span>'; aria += ', ' + d.people[i]; cls.push('pp' + (i % PP.length)); }
    if (calDayOff(dn)) cls.push('hol');
    if (dn === todayDn()) cls.push('today');
    if (dn === ui.sel) cls.push('sel');
    return '<button type="button" class="' + cls.join(' ') + '" data-dn="' + dn + '" aria-label="' + esc(aria) + '">' + inner + '</button>';
}
function renderMonth() {
    var r = S.monthRange(ui.y, ui.m), pad = S.mod(S.dow(r[0]) - WS, 7);
    var html = '<div class="ss-grid">' + weekHeader();
    for (var i = 0; i < pad; i++) html += '<span class="ss-day pad" aria-hidden="true"></span>';
    var c = st.mode === 'duty' ? null : E(), d = st.mode === 'duty' ? dutyCfg() : null;
    for (var dn = r[0]; dn <= r[1]; dn++) html += d ? dayCellDuty(d, dn) : dayCellShifts(c, dn);
    return html + '</div>';
}
function miniMonth(c, d, y, m) {
    var r = S.monthRange(y, m), pad = S.mod(S.dow(r[0]) - WS, 7), html = '';
    for (var i = 0; i < pad; i++) html += '<i class="pad"></i>';
    for (var dn = r[0]; dn <= r[1]; dn++) {
        var cls = '';
        if (d) { if (d.n && S.dutyIndex(d, dn) >= 0) cls = 'k-D'; }
        else {
            var x = S.cell(c, ui.crew, dn);
            cls = x.mark === 'vac' || x.mark === 'sick' ? x.mark : (S.WORK[x.k] ? 'k-' + x.k : '');
        }
        if (dn === todayDn()) cls += ' today';
        html += '<i class="' + cls + '"></i>';
    }
    return html;
}
function renderYear() {
    var c = st.mode === 'duty' ? null : E(), d = st.mode === 'duty' ? dutyCfg() : null, html = '<div class="ss-year">';
    for (var m = 1; m <= 12; m++) {
        var r = S.monthRange(ui.y, m), info = '';
        if (c) { var s = S.stats(c, ui.crew, r[0], r[1], statOpts()); info = t('th_shifts') + ' ' + s.shifts + ' · ' + hrs(s.min) + ' ' + t('h_unit'); }
        html += '<button type="button" class="ss-ym" data-m="' + m + '"><div class="ss-ym-h">' + esc(fmt(r[0], { month: 'long' })) + '<span>' + esc(info) + '</span></div>' +
            '<div class="ss-mini" aria-hidden="true">' + miniMonth(c, d, ui.y, m) + '</div></button>';
    }
    return html + '</div>';
}
function tableCell(c, crew, dn) {
    var x = S.cell(c, crew, dn);
    if (x.mark === 'vac' || x.mark === 'sick') return '<td class="' + x.mark + '" title="' + esc(t('mark_' + x.mark)) + '">' + esc(markLabel(x.mark)) + '</td>';
    if (S.WORK[x.k]) {
        var sg = S.segments(c, dn, x.k, x.short);
        return '<td class="k-' + x.k + '" title="' + esc(t('k_' + x.k) + ' ' + span(sg.s, sg.e)) + '">' + esc(t('l_' + x.k)) + '</td>';
    }
    return '<td>' + esc(t('l_O')) + '</td>';
}
function renderTable() {
    var r = S.monthRange(ui.y, ui.m), head = '<tr><th class="nm">' + esc(st.mode === 'duty' ? t('th_person') : t('th_crew')) + '</th>', dn;
    for (dn = r[0]; dn <= r[1]; dn++) {
        var w = S.dow(dn);
        head += '<th class="' + (isWeekend(w) || calDayOff(dn) ? 'we' : '') + '">' + nf0.format(S.ymdOf(dn).d) + '<br>' + esc(wdName(w, 'narrow')) + '</th>';
    }
    var html = '';
    if (st.mode === 'duty') {
        var d = dutyCfg();
        if (!d.n) return '<p class="tc-hint">' + esc(t('duty_empty')) + '</p>';
        head += '<th>' + esc(t('th_shifts')) + '</th></tr>';
        d.people.forEach(function (name, i) {
            var row = '<tr><td class="nm">' + esc(name) + '</td>', cnt = 0;
            for (var x = r[0]; x <= r[1]; x++) {
                var on = S.dutyIndex(d, x) === i;
                if (on) cnt++;
                row += on ? '<td class="k-D">●</td>' : '<td></td>';
            }
            html += row + '<td class="tot">' + cnt + '</td></tr>';
        });
        return '<div class="tc-tablewrap"><table class="ss-tab"><thead>' + head + '</thead><tbody>' + html + '</tbody></table></div>';
    }
    var c = E();
    head += '<th>' + esc(t('th_shifts')) + '</th><th>' + esc(t('th_hours')) + '</th><th>' + esc(t('th_night')) + '</th></tr>';
    for (var i = 0; i < st.crews.length; i++) {
        var row = '<tr><td class="nm">' + esc(crewName(i)) + '</td>';
        for (dn = r[0]; dn <= r[1]; dn++) row += tableCell(c, i, dn);
        var s = S.stats(c, i, r[0], r[1], statOpts());
        html += row + '<td class="tot">' + s.shifts + '</td><td class="tot">' + hrs(s.min) + '</td><td class="tot">' + hrs(s.night) + '</td></tr>';
    }
    var gaps = 0;
    if (st.crews.length > 1) {
        var used = S.kindSet(st.seq), row2 = '<tr class="cov"><td class="nm">' + esc(t('th_cov')) + '</td>';
        for (dn = r[0]; dn <= r[1]; dn++) {
            var cov = S.coverage(c, dn), parts = [], gap = false;
            used.forEach(function (k) { parts.push(cov[k]); if (!st.week && cov[k] === 0) gap = true; });
            if (gap) gaps++;
            row2 += '<td class="' + (gap ? 'gap' : '') + '">' + parts.join('/') + '</td>';
        }
        html += row2 + '<td colspan="3"></td></tr>';
    }
    var note = st.crews.length > 1 ? '<p class="tc-hint" style="margin-top:8px">' + esc(gaps ? t('cov_gaps', { n: gaps }) : t('cov_ok')) + ' ' + esc(t('legend_cov', { kinds: S.kindSet(st.seq).map(function (k) { return t('k_' + k).toLowerCase(); }).join('/') })) + '</p>' : '';
    return '<div class="tc-tablewrap"><table class="ss-tab"><thead>' + head + '</thead><tbody>' + html + '</tbody></table></div>' + note +
        '<p class="tc-hint" style="margin-top:6px">' + esc(t('table_hint')) + '</p>';
}
function renderLegend() {
    var parts = [];
    if (st.mode === 'shifts') {
        S.kindSet(st.seq).forEach(function (k) { parts.push('<span><i class="ss-dot k-' + k + '"></i>' + esc(t('l_' + k) + ' — ' + t('k_' + k).toLowerCase()) + '</span>'); });
    } else {
        people().slice(0, 24).forEach(function (n, i) { parts.push('<span><i class="ss-dot pp' + (i % PP.length) + '"></i>' + esc(n) + '</span>'); });
    }
    if (st.cal === 'ru') {
        parts.push('<span style="color:var(--lg-danger);font-weight:800">12</span><span>' + esc(t('legend_hol')) + '</span>');
        if (st.mode === 'shifts') parts.push('<span>12* ' + esc(t('legend_short')) + '</span>');
    }
    if (st.mode === 'shifts' && cmpE()) parts.push('<span><i class="ss-dot ss-both-dot"></i>' + esc(t('legend_both')) + '</span>');
    parts.push('<span><i class="ss-dot" style="box-shadow:0 0 0 2px var(--lg-accent) inset;background:none"></i>' + esc(t('legend_today')) + '</span>');
    $('ssLegend').innerHTML = parts.join('');
}
function renderCal() {
    var head = ui.view === 'year' ? String(ui.y) : cap(monthName(ui.y, ui.m));
    $('ssMonth').textContent = head;
    $('ssPrev').setAttribute('aria-label', ui.view === 'year' ? t('btn_prev_year') : t('btn_prev'));
    $('ssNext').setAttribute('aria-label', ui.view === 'year' ? t('btn_next_year') : t('btn_next'));
    setSeg($('ssView'), ui.view);
    var pick = $('ssCrewView');
    var showPick = st.mode === 'shifts' && st.crews.length > 1 && ui.view !== 'table';
    pick.hidden = !showPick;
    if (showPick) {
        var opts = '';
        st.crews.forEach(function (c, i) { opts += '<option value="' + i + '"' + (i === ui.crew ? ' selected' : '') + '>' + esc(crewName(i)) + '</option>'; });
        if (pick.innerHTML !== opts) pick.innerHTML = opts;
    }
    var cal = $('ssCal');
    cal.innerHTML = ui.view === 'year' ? renderYear() : ui.view === 'table' ? renderTable() : renderMonth();
    renderLegend();
    renderDayInfo();
}
function renderDayInfo() {
    var el = $('ssDayInfo'), dn = ui.sel;
    if (dn === null || ui.view !== 'month') { el.textContent = ''; return; }
    var txt = dayLong(dn) + ': ';
    if (st.mode === 'duty') {
        var d = dutyCfg(), i = d.n ? S.dutyIndex(d, dn) : -1;
        txt += i >= 0 ? t('now_duty', { name: d.people[i] }) : t('now_duty_none');
    } else {
        var c = E(), x = S.cell(c, ui.crew, dn);
        if (S.WORK[x.k]) {
            var sg = S.segments(c, dn, x.k, x.short), one = S.shifts(c, ui.crew, dn, dn).filter(function (q) { return q.dn === dn; })[0];
            var w = one ? shiftWork(c, one) : { work: 0, night: 0, dst: 0 };
            txt += t('dayinfo_shift', { kind: kp(x.k), span: span(sg.s, sg.e), h: hrs(w.work) });
            if (w.night) txt += ' · ' + t('dayinfo_night', { h: hrs(w.night) });
            if (w.dst) txt += ' · ' + t(w.dst < 0 ? 'dayinfo_dst_spring' : 'dayinfo_dst_fall');
        } else txt += t('dayinfo_off');
        if (x.mark) txt += ' · ' + t('mark_' + x.mark);
        if (st.cal === 'ru' && S.ruHoliday(dn)) txt += ' · ' + t('dayinfo_hol');
        if (st.cal === 'ru' && S.ruShort(dn)) txt += ' · ' + t('dayinfo_short');
    }
    el.textContent = txt;
}

/* ── рендер: числа ────────────────────────────────────────────────────── */
function tile(l, v, sub, cls) {
    return '<div class="tc-stat' + (cls ? ' ' + cls : '') + '"><div class="tc-stat-l">' + esc(l) + '</div><div class="tc-stat-v">' + esc(v) + '</div>' +
        (sub ? '<div class="tc-stat-s">' + esc(sub) + '</div>' : '') + '</div>';
}
function kindsLine(s) {
    var p = [];
    KINDS.forEach(function (k) { if (s.byKind[k]) p.push(t('k_' + k) + ' ×' + s.byKind[k]); });
    return p.join(' · ');
}
function devTile(s) {
    if (s.norm === null || s.dev === null) return '';
    if (Math.abs(s.dev) < 1) return tile(t('st_even'), '0', '', 'good');
    return s.dev > 0 ? tile(t('st_over'), '+' + hrs(s.dev), '', 'warn') : tile(t('st_under'), '−' + hrs(-s.dev), '', '');
}
/* Начислено до налогов: часы × ставка + доплата за ночные + праздничные сверх
   одинарной (ст. 153: не менее двойной). Сверхурочные при суммированном учёте
   считаются в конце учётного периода — в оценку не входят, это сказано рядом. */
function payOf(s) {
    var P = st.pay;
    if (!(P && P.rate > 0)) return null;
    var v = P.rate * s.min / 60 + P.rate * (s.night / 60) * P.night / 100;
    if (st.cal === 'ru') v += P.rate * (s.holiday / 60) * (P.hol - 1);
    return v;
}
function statTiles(s, days) {
    var h = tile(t('st_shifts'), nf0.format(s.shifts), kindsLine(s), 'lead') + tile(t('st_hours'), hrs(s.min), '') + tile(t('st_night'), hrs(s.night), '');
    if (st.cal === 'ru') h += tile(t('st_holiday'), hrs(s.holiday), '');
    h += tile(t('st_week'), hrs(s.min * 7 / Math.max(1, days)), '');
    if (s.norm !== null) h += tile(t('st_norm'), hrs(s.norm), t('st_norm_sub', { w: st.weekly }) + (s.absent ? ' · ' + t('st_absent', { n: s.absent }) : ''));
    var pay = payOf(s);
    if (pay !== null) h += tile(t('st_pay'), nf0.format(Math.round(pay)), t('st_pay_sub'), 'lead');
    if (s.both != null) h += tile(t('st_both'), nf0.format(s.both), t('st_both_sub', { n: days }));
    return h + devTile(s);
}
function bothCount(c, from, to) {
    var c2 = cmpE();
    if (!c2) return null;
    var n = 0;
    for (var dn = from; dn <= to; dn++) if (bothFree(c, c2, dn)) n++;
    return n;
}
function renderStats() {
    var title = $('ssStatsTitle'), tiles = $('ssStats'), pl = $('ssPeriodLine'), yw = $('ssYearWrap'), nn = $('ssNormNote');
    pl.hidden = true; yw.hidden = true; nn.hidden = true;
    if (st.mode === 'duty') {
        title.textContent = t('h_stats_duty', { month: monthName(ui.y, ui.m) });
        var d = dutyCfg(), r = S.monthRange(ui.y, ui.m);
        if (!d.n) { tiles.innerHTML = ''; return; }
        var cnt = d.people.map(function () { return 0; });
        for (var x = r[0]; x <= r[1]; x++) { var i = S.dutyIndex(d, x); if (i >= 0) cnt[i]++; }
        tiles.innerHTML = d.people.map(function (n, j) { return tile(n, nf0.format(cnt[j]), t('duty_count')); }).join('');
        return;
    }
    var c = E(), crew = ui.crew, s;
    if (ui.view === 'year') {
        title.textContent = t('h_stats_year', { y: ui.y }) + (st.crews.length > 1 ? ' — ' + crewName(crew) : '');
        var rows = '', tot = { shifts: 0, byKind: { D: 0, N: 0, F: 0, S: 0 }, min: 0, night: 0, holiday: 0, norm: 0, dev: 0, absent: 0 }, normOk = st.cal === 'ru';
        for (var m = 1; m <= 12; m++) {
            var mr = S.monthRange(ui.y, m), ms = S.stats(c, crew, mr[0], mr[1], statOpts());
            tot.shifts += ms.shifts; tot.min += ms.min; tot.night += ms.night; tot.holiday += ms.holiday; tot.absent += ms.absent;
            KINDS.forEach(function (k) { tot.byKind[k] += ms.byKind[k]; });
            if (ms.norm === null) normOk = false; else { tot.norm += ms.norm; tot.dev += ms.dev; }
            rows += '<tr><td>' + esc(fmt(mr[0], { month: 'long' })) + '</td><td class="num">' + ms.shifts + '</td><td class="num">' + hrs(ms.min) + '</td><td class="num">' + hrs(ms.night) + '</td>' +
                (st.cal === 'ru' ? '<td class="num">' + hrs(ms.holiday) + '</td>' : '') +
                (normOk || ms.norm !== null ? '<td class="num">' + (ms.norm !== null ? hrs(ms.norm) : '—') + '</td><td class="num ' + (ms.dev > 0 ? 'over' : 'under') + '">' + (ms.dev !== null ? (ms.dev > 0 ? '+' : ms.dev < 0 ? '−' : '') + hrs(Math.abs(ms.dev)) : '—') + '</td>' : '') + '</tr>';
        }
        var hasNorm = st.cal === 'ru' && S.ruKnown(ui.y);
        if (!normOk) { tot.norm = null; tot.dev = null; }
        var yr = S.monthRange(ui.y, 1)[0], ye = S.monthRange(ui.y, 12)[1];
        tot.both = bothCount(c, yr, ye);
        tiles.innerHTML = statTiles(tot, ye - yr + 1);
        var head = '<tr><th>' + esc(t('th_month')) + '</th><th class="num">' + esc(t('th_shifts')) + '</th><th class="num">' + esc(t('th_hours')) + '</th><th class="num">' + esc(t('th_night')) + '</th>' +
            (st.cal === 'ru' ? '<th class="num">' + esc(t('th_holiday')) + '</th>' : '') + (hasNorm ? '<th class="num">' + esc(t('th_norm')) + '</th><th class="num">' + esc(t('th_dev')) + '</th>' : '') + '</tr>';
        rows += '<tr class="tot"><td>' + esc(t('th_total')) + '</td><td class="num">' + tot.shifts + '</td><td class="num">' + hrs(tot.min) + '</td><td class="num">' + hrs(tot.night) + '</td>' +
            (st.cal === 'ru' ? '<td class="num">' + hrs(tot.holiday) + '</td>' : '') +
            (hasNorm ? '<td class="num">' + hrs(tot.norm || 0) + '</td><td class="num ' + (tot.dev > 0 ? 'over' : 'under') + '">' + (tot.dev > 0 ? '+' : tot.dev < 0 ? '−' : '') + hrs(Math.abs(tot.dev || 0)) + '</td>' : '') + '</tr>';
        yw.innerHTML = '<table class="tc-table ss-ytab"><caption class="tc-sr">' + esc(t('h_stats_year', { y: ui.y })) + '</caption><thead>' + head + '</thead><tbody>' + rows + '</tbody></table>';
        yw.hidden = false;
        normNote(ui.y);
        return;
    }
    var r2 = S.monthRange(ui.y, ui.m);
    title.textContent = cap(monthName(ui.y, ui.m)) + (st.crews.length > 1 && ui.view !== 'table' ? ' — ' + crewName(crew) : '');
    s = S.stats(c, crew, r2[0], r2[1], statOpts());
    s.both = bothCount(c, r2[0], r2[1]);
    tiles.innerHTML = statTiles(s, r2[1] - r2[0] + 1);
    if (st.cal === 'ru' && st.period !== 'month') {
        var pr = S.periodRange(ui.y, ui.m, st.period), sp = S.stats(c, crew, pr.from, pr.to, statOpts());
        if (sp.norm !== null) {
            var dev = sp.dev > 0 ? t('st_over').toLowerCase() + ' ' + hrs(sp.dev) : sp.dev < 0 ? t('st_under').toLowerCase() + ' ' + hrs(-sp.dev) : t('st_even').toLowerCase();
            pl.innerHTML = esc(t('period_line', {
                period: t('per_' + st.period).toLowerCase(),
                range: monthShort(pr.m0) + (pr.m1 !== pr.m0 ? '–' + monthShort(pr.m1) : ''),
                hours: hrs(sp.min), norm: hrs(sp.norm), dev: dev,
            })).replace(/(\d[\d\s.,]*)/, '<b>$1</b>');
            pl.hidden = false;
        }
    }
    normNote(ui.y);
}
function normNote(y) {
    var nn = $('ssNormNote');
    if (st.cal !== 'ru' || st.mode !== 'shifts') { nn.hidden = true; return; }
    nn.textContent = S.ruKnown(y) ? t('norm_source', { act: S.RU_CAL[y].act }) : t('no_norm', { y: y });
    nn.hidden = false;
}

function render() {
    syncRemind();
    renderRail();
    renderNow();
    renderCal();
    renderStats();
}

/* ── выгрузки ─────────────────────────────────────────────────────────── */
function declare(out) {
    feature('export', { out: out, view: ui.view, range: ui.range, mode: st.mode });
    if (reported) return;
    reported = true;
    try { if (window.__aeToolComplete) window.__aeToolComplete({ out: out, mode: st.mode, p: st.preset, crews: st.crews.length, cal: st.cal }); } catch (e) {}
    if (drafts) { try { drafts.exported(); } catch (e) {} }
}
function fileBase() {
    /* «;» в имени Safari считает концом имени и обрезает файл до «Пост №» —
       замер WebKit 22.10: «Пост №2; смена» скачивался как «Пост №.png». */
    var base = String(st.title || '').replace(/;/g, ',') || t('file_base');
    if (window.__outputName && window.__outputName.sanitize) base = window.__outputName.sanitize(base) || t('file_base');
    else base = base.replace(/[\\/:*?"<>|]+/g, ' ').trim() || t('file_base');
    return base;
}
function rangeDays() {
    if (ui.range === 'year') return [S.dnOf(ui.y, 1, 1), S.monthRange(ui.y, 12)[1], String(ui.y)];
    var r = S.monthRange(ui.y, ui.m);
    return [r[0], r[1], ui.y + '-' + (ui.m < 10 ? '0' : '') + ui.m];
}
function download(blob, name, out) {
    if (!window.__downloadFile) return;
    Promise.resolve(window.__downloadFile(blob, name)).then(function (ok) { if (ok !== false) declare(out); });
}
function saveIcs() {
    var rg = rangeDays(), evs = [];
    if (st.mode === 'duty') {
        var d = dutyCfg();
        if (!d.n) { toast(t('duty_empty'), 'warning'); return; }
        var dutyKey = fingerprint([st.title, d.people, d.rule, d.every, st.duty.start, d.cal]);
        for (var dn = rg[0]; dn <= rg[1]; dn++) {
            var i = S.dutyIndex(d, dn);
            /* Дежурство — на весь день: напоминание накануне в 18:00 (за 6 ч до 00:00). */
            if (i >= 0) evs.push({ allDay: true, alarm: st.remind ? 360 : 0, dn: dn, title: t('now_duty', { name: d.people[i] }), uid: S.isoOf(dn) + '-duty-' + dutyKey + '@timbrica' });
        }
    } else {
        var c = E(), crew = ui.crew, many = st.crews.length > 1;
        /* Пометки в отпечаток не входят: отпуск, добавленный после выгрузки,
           меняет только свои дни, а не UID всех смен. */
        var key = fingerprint([st.title, st.seq, st.week, st.anchor, st.kinds, st.crews[crew], crewName(crew)]);
        S.shifts(c, crew, rg[0], rg[1]).forEach(function (sh) {
            if (sh.dn < rg[0] || sh.dn > rg[1]) return;
            var work = shiftWork(c, sh).work;
            evs.push({
                s: sh.s, e: sh.e, alarm: st.remind,
                title: cap(kp(sh.k)) + (many ? ' · ' + crewName(crew) : '') + (st.title ? ' · ' + st.title : ''),
                desc: cap(t('dayinfo_shift', { kind: kp(sh.k), span: span(sh.s, sh.e), h: hrs(work) })),
                uid: S.isoOf(sh.dn) + '-' + crew + '-' + sh.k + '-' + key + '@timbrica',
            });
        });
    }
    if (!evs.length) { toast(t('nothing'), 'warning'); diag('nothing_to_export', { out: 'ics' }); return; }
    var body = S.ics(evs, { name: st.title || t('ics_name') });
    download(new Blob([body], { type: 'text/calendar;charset=utf-8' }), fileBase() + '-' + rg[2] + '.ics', 'ics');
}
function saveCsv() {
    var rg = rangeDays(), rows = [];
    if (st.mode === 'duty') {
        var d = dutyCfg();
        if (!d.n) { toast(t('duty_empty'), 'warning'); return; }
        rows.push([t('csv_date'), t('csv_weekday'), t('csv_person')]);
        for (var dn = rg[0]; dn <= rg[1]; dn++) {
            var i = S.dutyIndex(d, dn);
            rows.push([S.isoOf(dn), wdName(S.dow(dn), 'short'), i >= 0 ? d.people[i] : '']);
        }
    } else {
        var c = E();
        rows.push([t('csv_date'), t('csv_weekday'), t('csv_crew'), t('csv_kind'), t('csv_start'), t('csv_end'), t('csv_hours'), t('csv_night'), t('csv_holiday'), t('csv_mark')]);
        for (var ci = 0; ci < st.crews.length; ci++) {
            for (var x = rg[0]; x <= rg[1]; x++) {
                var cl = S.cell(c, ci, x), row = [S.isoOf(x), wdName(S.dow(x), 'short'), crewName(ci), t('k_' + cl.k)];
                if (S.WORK[cl.k]) {
                    var sh = S.shifts(c, ci, x, x).filter(function (q) { return q.dn === x; })[0];
                    var w = shiftWork(c, sh);
                    row.push(S.isoOf(Math.floor(sh.s / DAY)) + ' ' + S.hm(sh.s), S.isoOf(Math.floor((sh.e - 1) / DAY) + (S.mod(sh.e, DAY) === 0 ? 1 : 0)) + ' ' + S.hm(sh.e),
                        Math.round(w.work / 6) / 10, Math.round(w.night / 6) / 10, Math.round(w.holiday / 6) / 10);
                } else row.push('', '', 0, 0, 0);
                row.push(cl.mark ? t('mark_' + cl.mark) : '');
                rows.push(row);
            }
        }
    }
    var body = '\uFEFF' + S.csv(rows, DEC);
    download(new Blob([body], { type: 'text/csv;charset=utf-8' }), fileBase() + '-' + rg[2] + '.csv', 'csv');
}
function copyLink() {
    var LZ = window.LZString;
    if (!LZ) { toast(t('copy_failed'), 'error'); return; }
    var url = location.origin + location.pathname + '#s=' + LZ.compressToEncodedURIComponent(JSON.stringify(st));
    var p = window.__copyText ? window.__copyText(url) : Promise.resolve(false);
    p.then(function (ok) {
        if (ok) { toast(t('link_copied'), 'success'); declare('link'); }
        else { diag('copy_failed', { what: 'link' }); try { window.prompt(t('copy_failed'), url); } catch (e) {} }
    });
}
function fromHash() {
    var h = String(location.hash || '');
    if (h.indexOf('#s=') !== 0 || !window.LZString) return null;
    try {
        var o = JSON.parse(window.LZString.decompressFromEncodedURIComponent(h.slice(3)) || 'null');
        return o ? upgrade(o) : null;
    } catch (e) { return null; }
}

/* ── лист для печати и PDF ────────────────────────────────────────────── */
function sheetCellMonth(c, d, dn) {
    var cls = calDayOff(dn) ? 'mcell hol' : 'mcell', inner = '<b>' + nf0.format(S.ymdOf(dn).d) + '</b>';
    if (d) {
        var i = d.n ? S.dutyIndex(d, dn) : -1;
        if (i >= 0) { inner += '<br>' + esc(d.people[i]); return '<td class="' + cls + '" style="background:' + PP[i % PP.length] + '">' + inner + '</td>'; }
    } else {
        var x = S.cell(c, ui.crew, dn);
        if (S.WORK[x.k]) { var sg = S.segments(c, dn, x.k, x.short); cls += ' k' + x.k; inner += ' ' + esc(t('l_' + x.k)) + '<br>' + esc(span(sg.s, sg.e)); }
        if (x.mark) { if (x.mark === 'vac' || x.mark === 'sick') cls += ' m' + x.mark; inner += '<br>' + esc(t('mark_' + x.mark)); }
    }
    return '<td class="' + cls + '">' + inner + '</td>';
}
function sheetMonthTable(c, d, y, m, mini) {
    var r = S.monthRange(y, m), pad = S.mod(S.dow(r[0]) - WS, 7), html = '<table><thead><tr>', i;
    for (i = 0; i < 7; i++) html += '<th>' + esc(wdName((WS + i) % 7, mini ? 'narrow' : 'short')) + '</th>';
    html += '</tr></thead><tbody><tr>';
    var col = 0;
    for (i = 0; i < pad; i++) { html += '<td></td>'; col++; }
    for (var dn = r[0]; dn <= r[1]; dn++) {
        if (col === 7) { html += '</tr><tr>'; col = 0; }
        if (mini) {
            var cls = calDayOff(dn) ? 'hol' : '';
            if (d) { if (d.n && S.dutyIndex(d, dn) >= 0) cls += ' kD'; }
            else { var x = S.cell(c, ui.crew, dn); if (x.mark === 'vac' || x.mark === 'sick') cls += ' m' + x.mark; else if (S.WORK[x.k]) cls += ' k' + x.k; }
            html += '<td class="' + cls + '">' + (calDayOff(dn) ? '<b>' + S.ymdOf(dn).d + '</b>' : S.ymdOf(dn).d) + '</td>';
        } else html += sheetCellMonth(c, d, dn);
        col++;
    }
    while (col < 7 && col > 0) { html += '<td></td>'; col++; }
    return html + '</tr></tbody></table>';
}
function sheetLegend() {
    var p = [];
    if (st.mode === 'shifts') {
        S.kindSet(st.seq).forEach(function (k) { p.push('<span><i style="background:' + SHEET[k] + '"></i>' + esc(t('l_' + k) + ' — ' + t('k_' + k).toLowerCase()) + '</span>'); });
        var used = {};
        st.crews.forEach(function (c, i) { Object.keys(st.marks[i] || {}).forEach(function (iso) { used[st.marks[i][iso]] = 1; }); });
        if (used.vac) p.push('<span><i style="background:' + SHEET.vac + '"></i>' + esc(t('mark_vac')) + '</span>');
        if (used.sick) p.push('<span><i style="background:' + SHEET.sick + '"></i>' + esc(t('mark_sick')) + '</span>');
    }
    if (st.cal === 'ru') p.push('<span><b style="color:#c62828">12</b> ' + esc(t('legend_hol')) + '</span>');
    return '<div class="lg">' + p.join('') + '</div>';
}
function sheetStatsLine(s) {
    var parts = [t('st_shifts') + ': ' + s.shifts, t('st_hours') + ': ' + hrs(s.min), t('st_night') + ': ' + hrs(s.night)];
    if (st.cal === 'ru') parts.push(t('st_holiday') + ': ' + hrs(s.holiday));
    if (s.norm !== null) parts.push(t('st_norm') + ': ' + hrs(s.norm), (s.dev >= 0 ? t('st_over') + ': +' : t('st_under') + ': −') + hrs(Math.abs(s.dev)));
    var pay = payOf(s);
    if (pay !== null) parts.push(t('st_pay') + ': ' + nf0.format(Math.round(pay)) + ' (' + t('st_pay_sub') + ')');
    return '<p>' + esc(parts.join(' · ')) + '</p>';
}
function sheetTitle() {
    var who = st.mode === 'shifts' && st.crews.length > 1 && ui.view !== 'table' ? ' — ' + crewName(ui.crew) : '';
    var base = st.title || (st.mode === 'duty' ? t('drafts_label_duty') : t('title_default'));
    if (ui.view === 'year') return t('sheet_year', { title: base, y: ui.y }) + who;
    if (ui.view === 'table') return t('sheet_table', { title: base, month: monthName(ui.y, ui.m) });
    return t('sheet_month', { title: base, month: cap(monthName(ui.y, ui.m)) }) + who;
}
function sheet() {
    var c = st.mode === 'duty' ? null : E(), d = st.mode === 'duty' ? dutyCfg() : null;
    var el = document.createElement('div');
    el.className = 'ss-sheet';
    if (RTL) el.setAttribute('dir', 'rtl');
    var html = '', sub = '';
    if (c) {
        sub = (st.preset === 'custom' ? st.seq.split('').map(function (k) { return t('l_' + k); }).join(' ') : t('p_' + st.preset)) +
            S.kindSet(st.seq).map(function (k) { var K = st.kinds[k]; return ' · ' + t('k_' + k) + ' ' + span(K.s, K.s + K.l); }).join('');
    }
    if (ui.view === 'year') {
        html += '<div class="yg">';
        for (var m = 1; m <= 12; m++) html += '<div><h3>' + esc(cap(fmt(S.dnOf(ui.y, m, 1), { month: 'long' }))) + '</h3>' + sheetMonthTable(c, d, ui.y, m, true) + '</div>';
        html += '</div>';
        if (c) {
            var tot = S.stats(c, ui.crew, S.dnOf(ui.y, 1, 1), S.monthRange(ui.y, 12)[1], statOpts());
            html += sheetStatsLine(tot);
        }
    } else if (ui.view === 'table') {
        var tab = document.createElement('div');
        tab.innerHTML = renderTable();
        var tb = tab.querySelector('table');
        html += tb ? tb.outerHTML.replace(/ class="ss-tab"/, '') : '';
    } else {
        html += sheetMonthTable(c, d, ui.y, ui.m, false);
        if (c) { var r = S.monthRange(ui.y, ui.m); html += sheetStatsLine(S.stats(c, ui.crew, r[0], r[1], statOpts())); }
    }
    el.innerHTML = (sub ? '<p>' + esc(sub) + '</p>' : '') + html + sheetLegend() +
        '<p>' + esc(t('sheet_generated', { date: fmt(todayDn(), { day: 'numeric', month: 'long', year: 'numeric' }), site: SITE })) + '</p>';
    /* Табель печатается теми же цветами, что и лист месяца. */
    Array.prototype.forEach.call(el.querySelectorAll('td[class^="k-"],td.vac,td.sick'), function (td) {
        var k = td.className.replace('k-', '');
        td.style.background = SHEET[k] || '';
    });
    var host = $('ssPrintHost');
    host.innerHTML = '';
    host.appendChild(el);
    return el;
}
function savePdf() {
    if (!window.__generatePDF) { toast(t('pdf_error'), 'error'); return; }
    var el = sheet();
    window.__generatePDF({
        element: el,
        title: sheetTitle(),
        filename: fileBase() + '-' + (ui.view === 'year' ? ui.y : ui.y + '-' + (ui.m < 10 ? '0' : '') + ui.m) + '.pdf',
        orientation: ui.view === 'year' ? 'portrait' : 'landscape',
        strings: { genError: t('pdf_error'), libError: t('pdf_error') },
    }).then(function (res) {
        if (res && res.ok) declare('pdf');
    });
}
function printSheet() {
    sheet();
    declare('print');
    try { window.print(); } catch (e) {}
}

/* ── картинка PNG: свой рисовальщик, пиксели под размер экспорта ─────── */
function roundRect(g, x, y, w, h, r) {
    g.beginPath();
    g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r);
    g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath();
}
/* Легенда картинки: виды смен из схемы, отпуск, больничный, красная дата. */
function drawLegend(g, y, font) {
    var W = 1080, P = 40, items = [];
    if (st.mode === 'shifts') {
        S.kindSet(st.seq).forEach(function (k) { items.push([SHEET[k], t('l_' + k) + ' — ' + t('k_' + k).toLowerCase()]); });
        var used = {};
        Object.keys(st.marks[ui.crew] || {}).forEach(function (iso) { used[st.marks[ui.crew][iso]] = 1; });
        if (used.vac) items.push([SHEET.vac, t('mark_vac')]);
        if (used.sick) items.push([SHEET.sick, t('mark_sick')]);
    }
    if (st.cal === 'ru') items.push(['#c62828', t('legend_hol')]);
    g.font = '500 18px ' + font; g.textAlign = RTL ? 'right' : 'left';
    var x = RTL ? W - P : P;
    items.forEach(function (it) {
        var w = g.measureText(it[1]).width + 34;
        if (RTL ? x - w < P : x + w > W - P) { y += 30; x = RTL ? W - P : P; }
        g.fillStyle = it[0];
        roundRect(g, RTL ? x - 18 : x, y - 15, 18, 18, 4); g.fill();
        g.fillStyle = '#374151';
        g.fillText(it[1], RTL ? x - 26 : x + 26, y);
        x += RTL ? -w : w;
    });
}
function drawPng() {
    var year = ui.view === 'year';
    var c = st.mode === 'duty' ? null : E(), d = st.mode === 'duty' ? dutyCfg() : null;
    var W = 1080, P = 40, font = 'system-ui,-apple-system,"Segoe UI",Roboto,Arial,sans-serif';
    var cv = document.createElement('canvas');
    var g, H, x0;
    function X(x, w) { return RTL ? W - x - w : x; }
    if (!year) {
        var r = S.monthRange(ui.y, ui.m), pad = S.mod(S.dow(r[0]) - WS, 7), n = r[1] - r[0] + 1, rows = Math.ceil((pad + n) / 7);
        var cw = (W - 2 * P) / 7, ch = 112, top = 150;
        H = top + rows * ch + 160;
        cv.width = W; cv.height = H; g = cv.getContext('2d');
        g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
        g.direction = RTL ? 'rtl' : 'ltr';
        g.textAlign = RTL ? 'right' : 'left';
        g.fillStyle = '#111827'; g.font = '800 40px ' + font;
        x0 = RTL ? W - P : P;
        g.fillText(cap(monthName(ui.y, ui.m)), x0, 70);
        g.font = '500 24px ' + font; g.fillStyle = '#4b5563';
        g.fillText((st.title || (d ? t('drafts_label_duty') : t('p_' + st.preset) || '')) + (c && st.crews.length > 1 ? ' — ' + crewName(ui.crew) : ''), x0, 106);
        g.textAlign = 'center';
        for (var i = 0; i < 7; i++) {
            var wd = (WS + i) % 7;
            g.fillStyle = isWeekend(wd) ? '#c62828' : '#6b7280'; g.font = '700 20px ' + font;
            g.fillText(wdName(wd, 'short'), X(P + i * cw, cw) + cw / 2, top - 14);
        }
        for (var dn = r[0]; dn <= r[1]; dn++) {
            var idx = pad + dn - r[0], col = idx % 7, row = Math.floor(idx / 7);
            var x = X(P + col * cw, cw) + 3, y = top + row * ch + 3, w = cw - 6, h = ch - 6, fill = '#f3f4f6', label = '', time = '', mark = '';
            if (d) { var di = d.n ? S.dutyIndex(d, dn) : -1; if (di >= 0) { fill = PP[di % PP.length]; label = d.people[di]; } }
            else {
                var xc = S.cell(c, ui.crew, dn);
                if (S.WORK[xc.k]) { var sg = S.segments(c, dn, xc.k, xc.short); fill = SHEET[xc.k]; label = t('l_' + xc.k); time = spanShort(sg.s, sg.e); }
                if (xc.mark) { mark = t('lm_' + xc.mark); if (xc.mark === 'vac' || xc.mark === 'sick') fill = SHEET[xc.mark]; }
            }
            g.fillStyle = fill; roundRect(g, x, y, w, h, 12); g.fill();
            if (dn === todayDn()) { g.strokeStyle = '#2563eb'; g.lineWidth = 4; roundRect(g, x + 2, y + 2, w - 4, h - 4, 10); g.stroke(); }
            g.textAlign = RTL ? 'right' : 'left';
            var tx = RTL ? x + w - 10 : x + 10;
            g.fillStyle = calDayOff(dn) ? '#c62828' : '#111827'; g.font = '800 26px ' + font;
            g.fillText(String(S.ymdOf(dn).d), tx, y + 32);
            g.fillStyle = '#111827';
            if (label) {
                g.font = (d ? '700 18px ' : '800 24px ') + font;
                var lab = label;
                while (lab.length > 1 && g.measureText(lab).width > w - 20) lab = lab.slice(0, -1);
                g.fillText(lab, tx, y + 64);
            }
            if (time) { g.font = '500 18px ' + font; g.fillStyle = '#374151'; g.fillText(time, tx, y + 92); }
            if (mark) { g.font = '700 16px ' + font; g.fillStyle = '#111827'; var mk = mark; while (mk.length > 1 && g.measureText(mk).width > w - 20) mk = mk.slice(0, -1); g.fillText(mk, tx, y + (time ? 64 : 92)); }
        }
        g.textAlign = RTL ? 'right' : 'left'; g.fillStyle = '#374151'; g.font = '600 22px ' + font;
        if (c) {
            var s = S.stats(c, ui.crew, r[0], r[1], statOpts());
            var line = t('st_shifts') + ' ' + s.shifts + ' · ' + t('st_hours') + ' ' + hrs(s.min) + ' · ' + t('st_night') + ' ' + hrs(s.night);
            g.fillText(line, x0, top + rows * ch + 46);
        }
        drawLegend(g, top + rows * ch + 90, font);
        g.fillStyle = '#9ca3af'; g.font = '500 18px ' + font; g.fillText(SITE, x0, H - 24);
    } else {
        var cols = 3, gw = (W - 2 * P - (cols - 1) * 24) / cols, cell = gw / 7, mh = 40 + 26 + 6 * cell, top2 = 120;
        H = top2 + 4 * (mh + 24) + 110;
        cv.width = W; cv.height = Math.ceil(H); g = cv.getContext('2d');
        g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, cv.height);
        g.direction = RTL ? 'rtl' : 'ltr'; g.textAlign = RTL ? 'right' : 'left';
        x0 = RTL ? W - P : P;
        g.fillStyle = '#111827'; g.font = '800 40px ' + font; g.fillText(String(ui.y) + (st.title ? ' · ' + st.title : ''), x0, 70);
        for (var mm = 1; mm <= 12; mm++) {
            var gi = mm - 1, gx = X(P + (gi % cols) * (gw + 24), gw), gy = top2 + Math.floor(gi / cols) * (mh + 24);
            var mr = S.monthRange(ui.y, mm), mpad = S.mod(S.dow(mr[0]) - WS, 7);
            g.textAlign = RTL ? 'right' : 'left'; g.fillStyle = '#111827'; g.font = '800 22px ' + font;
            g.fillText(cap(fmt(mr[0], { month: 'long' })), RTL ? gx + gw : gx, gy + 24);
            g.textAlign = 'center'; g.font = '600 14px ' + font;
            for (var k2 = 0; k2 < 7; k2++) {
                var wd2 = (WS + k2) % 7;
                g.fillStyle = isWeekend(wd2) ? '#c62828' : '#6b7280';
                g.fillText(wdName(wd2, 'narrow'), (RTL ? gx + gw - (k2 + 1) * cell : gx + k2 * cell) + cell / 2, gy + 52);
            }
            for (var dd = mr[0]; dd <= mr[1]; dd++) {
                var id2 = mpad + dd - mr[0], cx = RTL ? gx + gw - (id2 % 7 + 1) * cell : gx + (id2 % 7) * cell, cy = gy + 62 + Math.floor(id2 / 7) * cell;
                var f2 = '#f3f4f6';
                if (d) { if (d.n && S.dutyIndex(d, dd) >= 0) f2 = SHEET.D; }
                else { var x2 = S.cell(c, ui.crew, dd); if (x2.mark === 'vac' || x2.mark === 'sick') f2 = SHEET[x2.mark]; else if (S.WORK[x2.k]) f2 = SHEET[x2.k]; }
                g.fillStyle = f2; roundRect(g, cx + 2, cy + 2, cell - 4, cell - 4, 6); g.fill();
                g.fillStyle = calDayOff(dd) ? '#c62828' : '#111827'; g.font = '600 15px ' + font;
                g.fillText(String(S.ymdOf(dd).d), cx + cell / 2, cy + cell / 2 + 5);
            }
        }
        drawLegend(g, top2 + 4 * (mh + 24) + 20, font);
        g.textAlign = RTL ? 'right' : 'left'; g.fillStyle = '#9ca3af'; g.font = '500 18px ' + font;
        g.fillText(SITE, x0, cv.height - 24);
    }
    return cv;
}
function savePng() {
    var cv;
    try { cv = drawPng(); } catch (e) {
        if (window.__handleError) window.__handleError(e, 'shift_png_draw', { say: t('png_error') }); else toast(t('png_error'), 'error');
        return;
    }
    var name = fileBase() + '-' + (ui.view === 'year' ? ui.y : ui.y + '-' + (ui.m < 10 ? '0' : '') + ui.m) + '.png';
    if (!window.__canvasBlob) { toast(t('png_error'), 'error'); return; }
    window.__canvasBlob(cv, 'image/png').then(function (blob) { if (blob) download(blob, name, 'png'); }, function (e) {
        if (window.__handleError) window.__handleError(e, 'shift_png_blob', { say: t('png_error') }); else toast(t('png_error'), 'error');
    });
}

/* ── события ──────────────────────────────────────────────────────────── */
function bind() {
    $('ssMode').addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]'); if (!b) return;
        st.mode = b.getAttribute('data-v') === 'duty' ? 'duty' : 'shifts';
        if (st.mode === 'duty' && ui.view === 'table' && !people().length) ui.view = 'month';
        feature('mode', { m: st.mode });
        changed();
    });
    $('ssTitle').addEventListener('input', function () { st.title = this.value.slice(0, 80); feature('title'); save(); renderStats(); });
    $('ssPresets').addEventListener('click', function (e) { var b = e.target.closest('[data-p]'); if (b) setPreset(b.getAttribute('data-p')); });
    $('ssSeq').addEventListener('click', function (e) {
        var b = e.target.closest('[data-i]'); if (!b) return;
        var i = +b.getAttribute('data-i'), k = st.seq.charAt(i);
        var nk = CYCLE[(CYCLE.indexOf(k) + 1) % CYCLE.length];
        toCustom();
        st.seq = st.seq.slice(0, i) + nk + st.seq.slice(i + 1);
        feature('seq_edit');
        firstScheme();
        changed();
        var again = $('ssSeq').querySelector('[data-i="' + i + '"]'); if (again) again.focus();
    });
    $('ssSeqAdd').addEventListener('click', function () { toCustom(); st.seq = S.cleanSeq(st.seq + 'O'); feature('seq_len'); firstScheme(); changed(); });
    $('ssSeqDel').addEventListener('click', function () { if (st.seq.length > 1) { toCustom(); st.seq = st.seq.slice(0, -1); feature('seq_len'); firstScheme(); changed(); } });
    $('ssAnchor').addEventListener('change', function () { if (S.parseIso(this.value) !== null) { st.anchor = this.value; feature('anchor'); firstScheme(); changed(); } });
    $('ssCrewN').addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]'); if (!b) return;
        var n = Math.max(1, Math.min(6, +b.getAttribute('data-v')));
        while (st.crews.length < n) st.crews.push({ n: '', o: 0 });
        st.crews.length = n;
        autoCrews();
        if (ui.crew >= n) ui.crew = 0;
        if (n > 1 && ui.view === 'month') ui.view = 'table';
        if (n === 1 && ui.view === 'table') ui.view = 'month';
        feature('crews', { n: n });
        changed();
    });
    $('ssCrews').addEventListener('input', function (e) {
        var i = e.target.getAttribute('data-name'); if (i === null) return;
        st.crews[+i].n = e.target.value.slice(0, 40); feature('crew_name'); save(); renderCal(); renderStats(); renderNow();
    });
    $('ssCrews').addEventListener('click', function (e) {
        var b = e.target.closest('[data-off]'); if (!b) return;
        var i = +b.getAttribute('data-off'), L = st.week ? 7 : st.seq.length;
        st.crews[i].o = S.mod(st.crews[i].o + (+b.getAttribute('data-d')), L);
        feature('crew_offset');
        changed();
    });
    $('ssCrewAuto').addEventListener('click', function () { autoCrews(); feature('crew_auto'); changed(); });
    $('ssKinds').addEventListener('change', function (e) { if (e.target.matches('input[type=number]')) setKind(e.target); });
    $('ssMarkPick').addEventListener('click', function (e) {
        var b = e.target.closest('[data-m]'); if (!b) return;
        ui.mark = b.getAttribute('data-m') || '';
        if (ui.mark && ui.view !== 'month') ui.view = 'month';
        if (ui.mark) feature('mark_mode', { m: ui.mark });
        render();
    });
    $('ssMarksClear').addEventListener('click', function () { st.marks[ui.crew] = {}; feature('marks_clear'); changed(); });
    $('ssCalSel').addEventListener('change', function () { st.cal = this.value === 'ru' ? 'ru' : 'none'; feature('cal', { v: st.cal }); changed(); });
    $('ssWeekly').addEventListener('change', function () { st.weekly = +this.value || 40; feature('weekly', { w: st.weekly }); changed(); });
    $('ssPeriod').addEventListener('change', function () { st.period = this.value; feature('period', { p: st.period }); changed(); });
    [['ssNightFrom', 'nightFrom'], ['ssNightTo', 'nightTo']].forEach(function (p) {
        var inp = $(p[0]);
        var fn = function () { var v = S.parseHm(inp.value); if (v === null) { inp.value = S.hm(st[p[1]]); fieldNote(inp, 'err_time'); return; } st[p[1]] = v; feature('night', {}); changed(); };
        if (window.__timeCommit) window.__timeCommit(inp, fn); else inp.addEventListener('change', fn);
    });
    $('ssDutyList').addEventListener('input', function () { st.duty.people = this.value.slice(0, 4000); feature('duty_people'); save(); renderNow(); renderCal(); renderStats(); });
    $('ssDutyList').addEventListener('change', function () { var n = people().length; if (n) { feature('duty_count', { n: n > 20 ? '20+' : n > 7 ? '8-20' : String(n) }); firstScheme(); } });
    $('ssRule').addEventListener('click', function (e) { var b = e.target.closest('[data-v]'); if (!b) return; st.duty.rule = b.getAttribute('data-v'); feature('duty_rule', { r: st.duty.rule }); changed(); });
    $('ssEvery').addEventListener('change', function () { var v = parseInt(this.value, 10); if (v >= 1 && v <= 31) { st.duty.every = v; changed(); } else { this.value = st.duty.every; fieldNote(this, 'err_every'); } });
    $('ssDutyStart').addEventListener('change', function () { if (S.parseIso(this.value) !== null) { st.duty.start = this.value; feature('duty_start'); changed(); } });

    function shift(dir) {
        if (ui.view === 'year') ui.y += dir;
        else { ui.m += dir; if (ui.m < 1) { ui.m = 12; ui.y--; } if (ui.m > 12) { ui.m = 1; ui.y++; } }
        ui.sel = null;
        renderCal(); renderStats();
    }
    $('ssPrev').addEventListener('click', function () { shift(-1); feature('nav'); });
    $('ssNext').addEventListener('click', function () { shift(1); feature('nav'); });
    $('ssToday').addEventListener('click', function () { var o = S.ymdOf(todayDn()); ui.y = o.y; ui.m = o.m; ui.sel = todayDn(); feature('today'); renderCal(); renderStats(); });
    $('ssView').addEventListener('click', function (e) { var b = e.target.closest('[data-v]'); if (!b) return; ui.view = b.getAttribute('data-v'); ui.sel = null; feature('view', { v: ui.view }); renderCal(); renderStats(); });
    $('ssCrewView').addEventListener('change', function () { ui.crew = +this.value || 0; feature('crew_view'); render(); });
    $('ssCal').addEventListener('click', function (e) {
        var ym = e.target.closest('.ss-ym');
        if (ym) { ui.m = +ym.getAttribute('data-m'); ui.view = 'month'; renderCal(); renderStats(); return; }
        var b = e.target.closest('[data-dn]'); if (!b) return;
        var dn = +b.getAttribute('data-dn');
        if (ui.mark && st.mode === 'shifts') {
            var bag = st.marks[ui.crew] || (st.marks[ui.crew] = {}), iso = S.isoOf(dn);
            if (bag[iso] === ui.mark) delete bag[iso]; else bag[iso] = ui.mark;
            feature('mark', { m: ui.mark });
            ui.sel = dn;
            changed();
            var again = $('ssCal').querySelector('[data-dn="' + dn + '"]'); if (again) again.focus();
            return;
        }
        ui.sel = ui.sel === dn ? null : dn;
        feature('day_info');
        Array.prototype.forEach.call($('ssCal').querySelectorAll('.ss-day.sel'), function (x) { x.classList.remove('sel'); });
        if (ui.sel !== null) b.classList.add('sel');
        renderDayInfo();
    });
    $('ssRemind').addEventListener('change', function () { var v = +this.value; if (REMINDS.indexOf(v) >= 0) { st.remind = v; feature('remind', { m: v }); save(); } });
    $('ssPayRate').addEventListener('change', function () {
        var v = this.value === '' ? 0 : parseFloat(String(this.value).replace(',', '.'));
        if (!(v >= 0 && v <= 1e6)) { this.value = st.pay.rate > 0 ? st.pay.rate : ''; fieldNote(this, 'err_rate'); return; }
        st.pay.rate = Math.round(v * 100) / 100; feature('pay_rate'); changed();
    });
    $('ssPayNight').addEventListener('change', function () {
        var v = parseInt(this.value, 10);
        if (!(v >= 0 && v <= 300)) { this.value = st.pay.night; fieldNote(this, 'err_pay_night'); return; }
        st.pay.night = v; feature('pay_night'); changed();
    });
    $('ssPayHol').addEventListener('change', function () { var v = +this.value; if (HOLX.indexOf(v) >= 0) { st.pay.hol = v; feature('pay_hol', { x: v }); changed(); } });
    $('ssCmpPreset').addEventListener('change', function () { var v = this.value; if (v === '' || S.preset(v)) { st.cmp.p = v; if (v) feature('compare', { p: v }); changed(); } });
    $('ssCmpAnchor').addEventListener('change', function () { if (S.parseIso(this.value) !== null) { st.cmp.a = this.value; feature('compare_anchor'); changed(); } });
    $('ssRange').addEventListener('click', function (e) { var b = e.target.closest('[data-v]'); if (!b) return; ui.range = b.getAttribute('data-v'); feature('range', { v: ui.range }); setSeg($('ssRange'), ui.range); });
    $('ssIcs').addEventListener('click', saveIcs);
    $('ssCsv').addEventListener('click', saveCsv);
    $('ssPdf').addEventListener('click', savePdf);
    $('ssPng').addEventListener('click', savePng);
    $('ssPrint').addEventListener('click', printSheet);
    $('ssLink').addEventListener('click', copyLink);
    /* Полночь и смена часа меняют «Сегодня» без единого нажатия. */
    setInterval(function () { if (!document.hidden) renderNow(); }, 60000);
}

function draftBoot(linked) {
    if (!window.__toolDraft || !window.__toolDraft.editor || !$('ssDrafts')) return Promise.resolve();
    drafts = window.__toolDraft.editor({
        slug: SLUG, root: 'ssDrafts', icon: '📆', locale: LOC, debounceMs: 500,
        payload: function () { return { state: clone(st), label: label() }; },
        apply: function (d) { st = upgrade(d && d.state); ui.crew = 0; render(); return Promise.resolve([]); },
        fresh: function () { st = fresh(); ui.crew = 0; ui.mark = ''; render(); },
        started: function () { return touched; },
        t: function (k, f) { return f; },
        /* Действия «Моих графиков» — feature_use, а не стадии: «draft_left» при уходе
           становился последней стадией воронки и прятал, где человек остановился. */
        track: function (a, data) { feature('draft', Object.assign({ a: a }, data || {})); },
        toast: toast,
    });
    return Promise.resolve(drafts.boot()).then(function () {
        if (linked && drafts.adopt) {
            drafts.adopt(true);
            try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
        }
    });
}

function boot() {
    var linked = fromHash();
    if (linked) { st = linked; touched = true; }
    else if (window.__toolSettings) {
        var last = window.__toolSettings.load(SLUG, 'last', null);
        if (last) st = upgrade(last);
    }
    bind();
    render();
    stage('ready', { linked: linked ? 1 : 0 });
    draftBoot(!!linked).then(function () { render(); }, function () { render(); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
